export default __webpack_public_path__ + "static/media/new_ebis2.d4e4087d.png";